module.exports = __webpack_public_path__ + "static/media/13a-03_Tablas-&-camas-2013-284x176mm-oleo-sobre-revista-National-Geographic-y-madera.361db5e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13a/13a-03_Tablas-&-camas-2013-284x176mm-oleo-sobre-revista-National-Geographic-y-madera.png
// module id = 128
// module chunks = 0